import { Check, ChevronDown } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { FormFieldLabel, FormHelperText } from "../app/FormField";

interface DropdownProps {
  label?: string;
  className?: string;
  name?: string;
  options: any[];
  optionsLength?: number;
  value?: string | number;
  onChange?: (value: string | number) => void;
  placeholder?: string;
  fullWidth?: boolean;
  width?: number;
  labelClassName?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  optional?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  label = "",
  className,
  options,
  optionsLength = 5,
  value,
  onChange,
  placeholder = "Select",
  fullWidth = false,
  width,
  labelClassName,
  error,
  helperText,
  required = false,
  optional = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", (e) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(e.target as Node)
        ) {
          setIsOpen(false);
        }
      });
    } else {
      document.removeEventListener("click", () => setIsOpen(false));
    }
  }, [isOpen]);

  return (
    // <select
    //   value={value}
    //   onChange={(e) => onChange(e.target.value)}
    //   className="border px-4 py-2 rounded w-1/3"
    // >
    //   <option value="">{placeholder}</option>
    //   {options.map((option) => (
    //     <option key={option.value} value={option.value}>
    //       {option.label}
    //     </option>
    //   ))}
    // </select>
    <div
      ref={dropdownRef}
      className={`relative ${className} ${
        fullWidth ? "w-full" : !width ? `w-fit` : `w-[${width}px] flex-shrink-0`
      }`}
      style={{ width: width ? width : undefined }}
    >
      <FormFieldLabel label={label} required={required} optional={optional} />

      <button
        className={`bg-white relative border pl-2 pr-6 py-2 rounded text-md text-center w-full flex-shrink-0`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {options.find((option) => option.value === value)?.label || placeholder}
        <ChevronDown className="w-4 h-4 absolute right-2 top-1/2 -translate-y-1/2" />
      </button>
      <div
        className={`absolute top-full left-0 w-full bg-white shadow-md z-10 ${
          isOpen ? "block" : "hidden"
        } ${
          optionsLength > 5
            ? `h-[${optionsLength * 40}px] overflow-y-auto`
            : "max-h-[200px] overflow-y-auto"
        }`}
      >
        {options.map((option) => (
          <button
            key={option.value}
            value={option.value}
            onClick={() => {
              onChange?.(option.value);
              setTimeout(() => {
                setIsOpen(false);
              }, 100);
            }}
            className={`relative w-full text-sm text-left pl-6 pr-6 py-2 active:bg-gray-100 flex items-center justify-center gap-2 ${
              value === option.value ? "bg-gray-100" : ""
            }`}
          >
            <p className="w-4 h-4 flex items-center justify-center absolute left-2 top-1/2 -translate-y-1/2">
              {value === option.value && (
                <Check className="w-4 h-4 text-green-500 font-bold stroke-[4px]" />
              )}
            </p>
            {/* <div className="text-sm flex items-center justify-center text-black"> */}
            {option.label}
            {/* </div> */}
          </button>
        ))}
      </div>

      <FormHelperText helperText={helperText} error={error} />
    </div>
  );
};

export default Dropdown;
